import {Injectable, Injector} from "@angular/core";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "./custom-object-type-search.model";

@Injectable()
export class MembershipTypeCustomObjectTypeSearchModel extends CustomObjectTypeSearchModel {
    constructor(injector: Injector) {
        super(injector);
        this.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
    }

    override getResource(): string {
        return "custom-membership-group-type";
    }
}
